import { createSelector } from '@reduxjs/toolkit';

import { getInsertingObjectInfo } from './insertionObjectSelectors';

export const isInsertingComponentDesign = createSelector(
  getInsertingObjectInfo,
  (info) => info?.type === 'componentDesign',
);
